import { Box, useRadio } from "@chakra-ui/react"

function RadioCard({ children, control, ...props }) {
  const { getInputProps, getCheckboxProps } = useRadio(props)

  const input = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="sm"
        _checked={{
          bg: "custom.primary",
          color: "white",
          borderColor: "custom.primary",
        }}
        _focus={{
          boxShadow: "outline",
        }}
        fontSize="0.875em"
        px={4}
        py={2}
      >
        {children}
      </Box>
    </Box>
  )
}

export default RadioCard
